// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"header-module--hamburger--32mQ4","displayed":"header-module--displayed--2gDx_","nav":"header-module--nav--2TcPd","active":"header-module--active--2pIok"};